module.exports = __webpack_public_path__ + "files/a668aba1ce9435a16efa5d3a448d97e0.png";